import { Component, inject, OnInit } from '@angular/core';
import { AssmatFormation, AssmatFormationProgramme } from '@app/models/ass-mat';
import { UserService } from '@app/services';
import { AssmatService } from '@app/services/assmat.service';

@Component({
  selector: 'app-assmat-formation',
  templateUrl: './assmat-formation.component.html',
  styleUrl: './assmat-formation.component.scss',
  standalone: false
})
export class AssmatFormationComponent implements OnInit {

  assmatService: AssmatService = inject(AssmatService);
  userService: UserService = inject(UserService)

  ngOnInit(): void {
    this.assmatService.getFormations(this.userService.currentUser.idAssmat).subscribe((formations: AssmatFormationProgramme) => {
      console.log(formations);

    })
  }
}
